import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
export const LRSearchResults = (props) => {
  return (
    <div className="card">
      <div className="pnr-row bg2">
        <div className="lr-box flex-2 box-padding border-right">
          <div className="heading pnr"> MBGLR/20-21/149</div>
          <div className="details manual">Manual LR:250</div>
        </div>
        <div className="lr-select flex-1 box-padding">
          <button className="select-pnr flex-center-all" value="Select">
            Select
          </button>
        </div>
      </div>
      <div className="branch-row">
        <div className="route-box flex-2 box-padding border-right">
          <div className="heading route">
            Banglore <span className="arrow-right"></span> Ahmedabad
          </div>
          <div className="details ro-branch">To Branch:Ahmedabad Bus Stand</div>
        </div>
        <div className="amount-box flex-1 box-padding">
          <div className="big-heading flex-center-all alsp">₹500.00</div>
        </div>
      </div>
      <div className="item-row bg2">
        <div className="item-box flex-1 box-padding border-right">
          <div className="detail item">Item</div>
          <div className="heading item">School bag</div>
        </div>
        <div className="desc-box flex-1 box-padding border-right">
          <div className="details desc">Desc</div>
          <div className="heading desc">Sack Items</div>
        </div>
        <div className="pay-type flex-1 box-padding">
          <div className="details pay-type">Payment Type</div>
          <div className="heading pay-type">Paid</div>
        </div>
      </div>
      <div className="sender-row">
        <div className="sender-box flex-1 box-padding border-right">
          <div className="details name">Sender</div>
          <div className="heading name link">Amit Aurora</div>
        </div>
        <div className="receiver-box flex-1 box-padding border-right">
          <div className="details rec">Receiver Name</div>
          <div className="heading rec link">Harshit</div>
        </div>
        <div className="details-box flex-1 box-padding">
          <div className="alsp flex-center-all">
            <div className="more heading link">More</div>
            <div className="plus-minus">
              <AddCircleRoundedIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
